import { Link } from 'react-router-dom';
import { getNewVideos } from '@/mocks/videos';
import { getLatestArticles } from '@/mocks/articles';

export default function LatestSection() {
  const newVideos = getNewVideos();
  const latestArticles = getLatestArticles(4);

  return (
    <section className="w-full px-4 md:px-6 lg:px-8 py-10 md:py-14 bg-background-50">
      <div className="max-w-7xl mx-auto">
        {/* New Videos */}
        <div className="mb-12">
          <div className="flex items-center justify-between mb-8">
            <div>
              <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-1">
                最新上线
              </h2>
              <p className="text-sm text-foreground-600">刚刚更新的热门影视</p>
            </div>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
            {newVideos.map((video) => (
              <Link
                key={video.id}
                to={`/article/${video.id}`}
                className="group bg-background-50 rounded-xl overflow-hidden border border-background-200/70 cursor-pointer transition-all hover:scale-[1.02]"
              >
                <div className="relative aspect-video overflow-hidden">
                  <img
                    src={video.thumbnail}
                    alt={video.title}
                    className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
                  />
                  <div className="absolute top-2 left-2">
                    <span className="px-2 py-0.5 text-[10px] font-medium bg-accent-500 text-white rounded-full whitespace-nowrap">
                      NEW
                    </span>
                  </div>
                </div>
                <div className="p-3">
                  <h3 className="font-heading font-semibold text-foreground-950 text-sm mb-1 group-hover:text-primary-600 transition-colors line-clamp-1">
                    {video.title}
                  </h3>
                  <div className="flex items-center justify-between">
                    <span className="text-xs text-foreground-500">{video.source}</span>
                    <span className="text-xs text-accent-600 font-medium">{video.rating}</span>
                  </div>
                </div>
              </Link>
            ))}
          </div>
        </div>

        {/* Latest Articles */}
        <div>
          <div className="flex items-center justify-between mb-8">
            <div>
              <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-1">
                影视资讯
              </h2>
              <p className="text-sm text-foreground-600">最新影视动态与深度解析</p>
            </div>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 md:gap-5">
            {latestArticles.map((article) => (
              <Link
                key={article.id}
                to={`/article/${article.slug}`}
                className="group flex flex-col sm:flex-row bg-background-50 rounded-xl overflow-hidden border border-background-200/70 cursor-pointer transition-all hover:scale-[1.01]"
              >
                <div className="sm:w-48 flex-shrink-0 aspect-video sm:aspect-auto overflow-hidden">
                  <img
                    src={article.coverImage}
                    alt={article.title}
                    className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
                  />
                </div>
                <div className="p-4 flex flex-col justify-center flex-1">
                  <span className="text-[10px] uppercase tracking-wide text-primary-600 font-medium mb-1">
                    {article.category}
                  </span>
                  <h3 className="font-heading font-semibold text-foreground-950 text-sm mb-2 group-hover:text-primary-600 transition-colors line-clamp-2">
                    {article.title}
                  </h3>
                  <p className="text-xs text-foreground-600 line-clamp-2 leading-relaxed mb-3">
                    {article.excerpt}
                  </p>
                  <div className="flex items-center gap-3 text-xs text-foreground-500">
                    <span>{article.publishDate}</span>
                    <span>·</span>
                    <span>{article.readTime}阅读</span>
                  </div>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}